import type {AssignUserRoleFormPayload} from "./assign-user-role.schema";
import {assignAccessAdministrationUserRole} from "@project/sdk/access-administration";
import {AssignAccessAdministrationUserRoleResponse} from "@project/sdk/access-administration/zod";
import {mutationOptions} from "@tanstack/react-query";
import {accessAdministrationMutationKeys, userAccessKeys} from "../../access-administration-keys";

export function assignUserRoleMutationOptions(userId: string) {
  return mutationOptions({
    mutationKey: accessAdministrationMutationKeys.assignUserRole,
    mutationFn: async (payload: AssignUserRoleFormPayload) =>
      AssignAccessAdministrationUserRoleResponse.parse(
        await assignAccessAdministrationUserRole(userId, payload),
      ),
    onSuccess: async (_data, _variables, _context, {client}) => {
      await client.invalidateQueries({queryKey: userAccessKeys.detail(userId)});
    },
  });
}
